module.exports = __webpack_public_path__ + "img/slika0.8a88f3fe.jpg";